module.exports = __webpack_public_path__ + "8fb533b29ce919404c49054d27d09492.svg";